import React, { useState, useEffect } from "react";
import { Button, FormGroup, FormControl } from "react-bootstrap";
import "./style.css";
import { Card } from 'react-bootstrap';
import LoginLogo from "../../assets/images/skye-innoveo_color-blue.png";
import HelperServices from '../../services/CommonServices';
import {Constants} from '../../data/Constants';
import Modal from 'react-bootstrap/Modal';
export default function Login(props) {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [modalInfo, setModalInfo] = useState('');
  const [modalHeading, setModalHeading] = useState('');
  const [show, setShow] = useState(false);

  function validateForm() {
    return userName.length > 0 && password.length > 0;
  }

  function handleSubmit(event) {
    event.preventDefault();
    props.login(userName, password);
  }

  useEffect(() => {
    checkOverallHealth();
  }, []);

  useEffect(() => {
    if (props.authenticate === true) {
      props.history.push('/');
    }
  }, [props.authenticate]);

  function handleShow() {
    setShow(true);
  }

  function handleClose() {
    setShow(false);
    window.location.reload();
  }

  function checkOverallHealth() {
    HelperServices.checkOverallHealth().then(response => {
      if (!response) {
        const modalInfo = (
            <div>
              <i className="fad fa-exclamation-circle dialog-warning-icon"></i>
              <h3>{Constants.headerOverallHealth}</h3>
              <span>{Constants.overallHealthMessage}</span>
              <br/>
              <br/>
              <div className="right-side">
                <button className="btn button-global modal-ok" onClick={handleClose}>OK</button>
              </div>
            </div>)
        setModalInfo(modalInfo);
        handleShow();
      }
    });
  }

  return (
    <div className="login-container">
      <div className="login">
        <Card className="login-card">
          <form onSubmit={handleSubmit} >
            <div className="login-img">
              <img src={LoginLogo} alt="Login Logo"/>
            </div>
            <FormGroup controlId="userName" bsSize="large">
              <label className="label">Username</label>
              <FormControl autoFocus type="userName" value={userName} onChange={e => setUserName(e.target.value)}/>
            </FormGroup>
            <FormGroup controlId="password" bsSize="large">
              <label className="label">Password</label>
              <FormControl value={password} onChange={e => setPassword(e.target.value)} type="password"/>
            </FormGroup>
            {props.loginError ?
              <div className="alert alert-danger alert-dismissible fade show">
                <strong>Invalid username or password</strong>
              </div>
              : null}
            <Button block bsSize="large" disabled={!validateForm()} type="submit">
              Login
            </Button>
          </form>
        </Card>
      </div>
      <Modal className="modal-style text-justify" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{modalHeading}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="table-view">
          {modalInfo}
        </Modal.Body>
      </Modal>
    </div>
  );
}